import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { getHomepageContent } from "@/lib/eisStore";

export default function EventsCarousel() {
  const homepage = getHomepageContent();
  const slides = homepage.events || [];

  return (
    <section data-testid="events-carousel-section" className="w-full">
      <h2
        className="text-2xl md:text-3xl font-bold mb-4"
        style={{ color: "#0b1f7a" }}
      >
        Recent Events
      </h2>

      <Carousel
        opts={{ loop: true, align: "start" }}
        className="w-full"
        data-testid="events-carousel"
      >
        <CarouselContent>
          {slides.map((slide) => (
            <CarouselItem
              key={slide.id}
              data-testid={`event-slide-${slide.id}`}
              className="md:basis-1/2 lg:basis-1/3"
            >
              <div className="relative aspect-[16/10] rounded-2xl overflow-hidden bg-slate-200 shadow-sm group">
                <img
                  src={slide.src}
                  alt="School event"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious data-testid="events-carousel-prev" />
        <CarouselNext data-testid="events-carousel-next" />
      </Carousel>
    </section>
  );
}
